var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCadisLogoMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 62.54 20.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2e6b24;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CadisLogoMobile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cadis-ico"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cadis-ico-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    className: "cls-1",
    d: "M25,20.92a5.31,5.31,0,0,1-5.53-5.06A5.31,5.31,0,0,1,25,10.8h9.52a5.31,5.31,0,0,1,5.53,5.06,5.31,5.31,0,0,1-5.53,5.06Zm-1.84-5.06a3.21,3.21,0,0,0,3.34,3.06,3.21,3.21,0,0,0,3.34-3.06,3.2,3.2,0,0,0-3.34-3A3.2,3.2,0,0,0,23.19,15.86Zm11.41,0c0,.93.4,1.68.9,1.68s.89-.75.89-1.68-.4-1.68-.89-1.68-.9.75-.9,1.68ZM0,8C29.4-2.1,25.5-3.19,62.54,8Z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCadisLogoMobile);
export default __webpack_public_path__ + "static/media/CadisLogoMobile.51e373cf0231e04d202572459d9b9e0b.svg";
export { ForwardRef as ReactComponent };